<template>
  <div class="login-right-style login-account-style">
    <div>
      <h1 class="header-title">账号密码登录</h1>
      <div class="header-nav"></div>
    </div>
    <el-form :model="info" :rules="rules" ref="loginForm">
      <el-form-item class="login-form-item" prop="account">
        <i class="iconfont iconzhanghao login-form-icon"></i>
        <el-input placeholder="请输入帐号" class="login-form-input" v-model="info.account" clearable />
      </el-form-item>
      <el-form-item class="login-form-item" prop="password">
        <i class="iconfont iconsuo login-form-icon"></i>
        <el-input placeholder="请输入密码" class="login-form-input" :type="isShowPsd ? 'text' : 'password'" v-model="info.password" clearable />
        <i class="iconfont icon-eyes" :class="isShowPsd ? 'iconkejian' : 'iconbukejian1'" @click="isShowPsd = !isShowPsd"></i>
      </el-form-item>
      <div class="clearfix">
        <p class="forget" @click="forgetPsw">忘记密码</p>
      </div>
      <el-button class="login-btn" style="margin-top: 25px;" @click="login" :loading="isLogining">登 录</el-button>
    </el-form>
  </div>
</template>
<script>
import {loginByAccount} from '@/api/login';
  export default {
    name: 'AccountComp',
    data () {
      return {
        info: {
          account: '',
          password: ''
        },
        rules: {
          account: [
            { required: true, trigger: 'blur', message: '请输入账号'}
          ],
          password: [
            { required: true, trigger: 'blur', message: '请输入密码'}
          ]
        },
        isLogining: false,
        isShowPsd: false
      }
    },
    created() {
      this.generateScript();
    },
    methods: {
      otherLoginByWechat () {
        this.$emit('toggle', {type: 1});
      },
      forgetPsw () {
        this.$emit('toggle', {type: 4});
      },
      login () {
        this.$refs?.loginForm?.validate?.(valid => {
          if (!valid) return null;
          // 打开滑块验证码
          this.openSliderVerify();
        })
      },
      openSliderVerify () {
        const _this = this;
        const captcha = new TencentCaptcha('2083949051',(res) => {
          // 用户确认但是客户端出现问题
          if (res.ret === 0 && res.errorCode) {
            this.$message.error(res.errorMessage);
          } else if (res.ret === 0) {
            // 用户校验成功
            _this.isLogining = true;
            _this.verrifySuccess(res);
          }
        }, {
          needFeedBack: false
        })
        captcha.show();
      },
      async verrifySuccess (data) {
        try {
          const res = await loginByAccount({
            ...this.info,
            captcha_ticket: data.ticket,
            captcha_rand_str: data.randstr
          });
          // 判断是否需要进去商户选择页面
          if (res.is_plural > 0) {
            this.$emit('toggle', {
              type: 3,
              params: {
                token: res.token,
                fromType: 0
              }
            })
          } else {
            this.$store.dispatch('user/login', res);
            this.$emit('login');
          }
        } catch (err) {
          this.$message.error(err.msg || '操作失败，请重试');
        } finally {
          this.isLogining = false;
        }
      },
      generateScript () {
        // 判断是否已经引入js
        try {
          if (TencentCaptcha) return null;
        } catch (err) {
          const script = document.createElement('script');
          script.src = "https://turing.captcha.qcloud.com/TCaptcha.js";
          $('body').append($(script));
        }
      },
    },
  }
</script>
<style scoped>
.forget{
  color: #3468FA;
  font-size: 14px;
  display: block;
  float: right;
  margin-top: 10px;
  cursor: pointer;
}
.login-account-style .login-other-group{
  margin-top: 30px;
}
.login-account-style{
  padding-bottom: 25px;
}
</style>
